import { useMemo } from 'react';
import { useAuth } from '@wix/cli-auth';
import type { CreateHttpClientOptions, HttpClient } from '@wix/cli-http-client';
import { createHttpClient } from '@wix/cli-http-client';

export function useHttpClient({
  type,
}: Pick<CreateHttpClientOptions, 'type'>): HttpClient {
  const { getAccessToken: getAppToken, getRequestHeaders: createHeaders } =
    useAuth();

  return useMemo(
    () => createHttpClient({ type, getAppToken, createHeaders }),
    [type, getAppToken, createHeaders]
  );
}
